import { getOptions, handleError } from "./API.js";
import { API, Logger } from "aws-amplify";
const logger = new Logger("file-retrieval");

const API_NAME = "PVAPI";

/**
 *  @return {Promise}
 */
export async function CreateDVRFileRequest(org, vehicleId, deviceId, params) {
  try {
    const options = await getOptions(params);
    const res = await API.post(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/filesets/requests`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function GetDVRFileRequestForUser(org, params) {
  try {
    const options = await getOptions();
    if (params) options.queryStringParameters = params;
    const res = await API.get(API_NAME, `/org/${org}/files/requests`, options);
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function GetDVRFileRequestByDevice(org, vehicleId, deviceId, fileSetId) {
  try {
    const options = await getOptions();
    const res = await API.get(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/filesets/requests/${fileSetId}`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function GetRecordingTimes(org, deviceId, params) {
  try {
    const options = await getOptions(params);
    logger.info("options", options);
    const res = await API.post(API_NAME, `/org/${org}/devices/id/${deviceId}/recordingtimes`, options);
    logger.info("recordingtimesResult", res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function CancelFileRequest(org, vehicleId, deviceId, fileId) {
  try {
    const options = await getOptions();
    const res = await API.del(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/files/requests/${fileId}/cancel`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function DeleteFileRequest(org, vehicleId, deviceId, fileId) {
  try {
    const options = await getOptions();
    const res = await API.del(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/files/requests/${fileId}/delete`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function CancelFilesetRequest(org, vehicleId, deviceId, fileId) {
  try {
    const options = await getOptions();
    const res = await API.del(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/filesets/requests/${fileId}/cancel`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function DeleteFilesetRequest(org, vehicleId, deviceId, fileId) {
  try {
    const options = await getOptions();
    const res = await API.del(
      API_NAME,
      `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/cloud/filesets/requests/${fileId}/delete`,
      options
    );
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export async function DownloadFile(org, fileId) {
  try {
    const options = await getOptions();
    const res = await API.get(API_NAME, `/org/${org}/files/requests/${fileId}/download`, options);
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}

/**
 *  @return {Promise}
 */
export function GetLogContent(url) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (res, rej) => {
    fetch(url).then(async result => {
      try {
        res(result.text())
      } catch (ex) {
        rej(ex)
        logger.debug("log contents", "error parsing response")
      }
    })
  })
}

/**
 *  @return {Promise}
 */
export async function ListAllFiles(org, vehicleId, deviceId, [start_time, end_time], fileType) {
  try {
    const options = await getOptions();
    const res = await API.get(API_NAME, `/org/${org}/vehicles/${vehicleId}/devices/${deviceId}/local/files?start_time=${start_time}&end_time=${end_time}&fileType=${fileType} `, options);
    logger.info(res);
    return res;
  } catch (err) {
    return handleError(err);
  }
}
